export const MONEY_BOX_BALANCE_LIST = 'MONEY_BOX_BALANCE_LIST'
